<template>

  <div class="app" v-if="createId !== 0">

    <div class="container" v-if="menuStatus === 0">
      <img class="pb" src="../src/assets/image/bg.jpg" alt="" srcset="">
    </div>


    <div class="container" v-if="menuStatus !== 0">

      <div class="title">
        <!-- <div class="title-time">
          <AppTime />
        </div> -->
        <div class="title-tip">
          今日菜单 - <span v-if="menuStatus === 1"> 早餐</span><span v-if="menuStatus === 2"> 中餐</span><span v-if="menuStatus === 3"> 晚餐</span>
        </div>
      </div>
      <!-- 中餐 menuStatus 2-->
      <div class="menus" v-if="menuStatus === 2">
        <div class="menus-column">
          <div class="menus-column-title">大荤</div>
          <div class="menus-column-content">
            <ul class="menus-column-content-ul" v-if="Menus_noon.dahun">
              <li class="menus-column-content-li" v-for="(item,index) in Menus_noon.dahun" v-bind:key="index">
                {{item}}
              </li>
            </ul>
          </div>
        </div>
        <div class="menus-column">
          <div class="menus-column-title">小荤</div>
          <div class="menus-column-content">
            <ul class="menus-column-content-ul" v-if="Menus_noon.xiaohun">
              <li class="menus-column-content-li" v-for="(item,index) in Menus_noon.xiaohun" v-bind:key="index">
                {{item}}
              </li>
            </ul>
          </div>
        </div>
        <div class="menus-column">
          <div class="menus-column-title">素菜</div>
          <div class="menus-column-content">
            <ul class="menus-column-content-ul" v-if="Menus_noon.sucai">
              <li class="menus-column-content-li" v-for="(item,index) in Menus_noon.sucai" v-bind:key="index">
                {{item}}
              </li>
            </ul>
          </div>
        </div>
        <div class="menus-column">
          <div class="menus-column-title">特别供应</div>
          <div class="menus-column-content">
            <ul class="menus-column-content-ul" v-if="Menus_noon.special">
              <li class="menus-column-content-li" v-for="(item,index) in Menus_noon.special" v-bind:key="index">
                {{item}}
              </li>
            </ul>
          </div>
        </div>

      </div>
      <!-- 晚餐 menuStatus 3-->
      <div class="menus" v-if="menuStatus === 3">
        <div class="menus-column">
          <div class="menus-column-title">大荤</div>
          <div class="menus-column-content">
            <ul class="menus-column-content-ul">
              <li class="menus-column-content-li" v-for="(item,index) in Menus_night.dahun" v-bind:key="index">
                {{item}}
              </li>
            </ul>
          </div>
        </div>
        <div class="menus-column">
          <div class="menus-column-title">小荤</div>
          <div class="menus-column-content">
            <ul class="menus-column-content-ul">
              <li class="menus-column-content-li" v-for="(item,index) in Menus_night.xiaohun" v-bind:key="index">
                {{item}}
              </li>
            </ul>
          </div>
        </div>
        <div class="menus-column">
          <div class="menus-column-title">素菜</div>
          <div class="menus-column-content">
            <ul class="menus-column-content-ul">
              <li class="menus-column-content-li" v-for="(item,index) in Menus_night.sucai" v-bind:key="index">
                {{item}}
              </li>
            </ul>
          </div>
        </div>
        <div class="menus-column">
          <div class="menus-column-title">特别供应</div>
          <div class="menus-column-content">
            <ul class="menus-column-content-ul">
              <li class="menus-column-content-li" v-for="(item,index) in Menus_night.special" v-bind:key="index">
                {{item}}
              </li>
            </ul>
          </div>
        </div>

      </div>
    </div>

    <div class="footer">
      <div class="footer-title">
        <span v-if="createId == 1">金山区山阳派出所</span>
        <span v-if="createId == 2"> 金山区金山卫派出所</span>
        
      </div>
      <div class="footer-tips">
        <div class="footer-tips-time"><AppTime /></div>
        <div class="footer-tips-weather"><AppWeather /></div>
      </div>
    </div>

  </div>

  <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
  <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
</template>

<script setup>
// import HelloWorld from './components/HelloWorld.vue'
// import AppTitle from './components/AppTitle.vue'
// import AppColumn from './components/AppColumn.vue'
// import AppFooter from './components/AppFooter.vue'

import AppTime from './components/AppTime.vue';
import AppWeather from './components/AppWeather.vue';
import { getMenu,getMenuList } from "@/api/index.js";
import dayjs from 'dayjs';
import { onMounted,ref } from 'vue';


// 地区标识 1：山阳、2：金山卫
const createId = ref(0)


// 所有菜品
const menus_list = ref({
    breakfast: {
        normal: [],
        special: []
    },
    lunch: {
        dahun: [],
        xiaohun: [],
        sucai: [],
        special: []
    },
    dinner: {
        dahun: [],
        xiaohun: [],
        sucai: [],
        special: []
    }
})

// 获取的菜品
const menusData = ref([])

// 根据传入地区标识获取菜单下拉框list 所有菜品
const getData = async(sid) => {

    let menuList_sy = await getMenuList({page: 1, pageSize: 999,createId: sid})
    if(menuList_sy.data.code == 1) {
      // console.log(menuList_sy.data.data.rows)

      let zaofan = menuList_sy.data.data.rows.filter(r => r.sid === 0)
      let zhongfan_val = menuList_sy.data.data.rows.filter(r => r.sid === 1)
      let tebie = menuList_sy.data.data.rows.filter(r => r.sid === 2)

      let zaofan_val = [];
      let tebie_val = [];

      for(let i = 0; i < zaofan.length; i++) {
        zaofan_val.push({value: zaofan[i]._id,label: zaofan[i].name})
      }

      for(let i = 0; i < tebie.length; i++) {
        tebie_val.push({value: tebie[i]._id,label: tebie[i].name})
      }

      let type_0 = zhongfan_val.filter(r => r.type === 0);
      let type_1 = zhongfan_val.filter(r => r.type === 1);
      let type_2 = zhongfan_val.filter(r => r.type === 2);

      menus_list.value.breakfast.normal = zaofan_val;
      menus_list.value.breakfast.special = tebie_val;

      if(type_0.length > 0) {
        for(let i = 0; i < type_0.length; i++) {
          menus_list.value.lunch.dahun.push({value: type_0[i]._id,label: type_0[i].name})
          menus_list.value.dinner.dahun.push({value: type_0[i]._id,label: type_0[i].name})
        }
      }

      if(type_1.length > 0) {
        for(let i = 0; i < type_1.length; i++) {
          menus_list.value.lunch.xiaohun.push({value: type_1[i]._id,label: type_1[i].name})
          menus_list.value.dinner.xiaohun.push({value: type_1[i]._id,label: type_1[i].name})
        }
      }

      if(type_2.length > 0) {
        for(let i = 0; i < type_2.length; i++) {
          menus_list.value.lunch.sucai.push({value: type_2[i]._id,label: type_2[i].name})
          menus_list.value.dinner.sucai.push({value: type_2[i]._id,label: type_2[i].name})
        }
      }


      menus_list.value.lunch.special = tebie_val;
      menus_list.value.dinner.special = tebie_val;
      // console.log('menus_list:',menus_list.value);

      getMenuData(createId.value);

    } else {
      console.log('网络错误')


    }
}



// 根据传入的日期 获取已经选择的菜品
const getMenuData = (sid) => {
  var _date = new Date();
  let _year = dayjs(_date).year();
  let _month = (dayjs(_date).month() + 1);
  let _day = dayjs(_date).date();
  
  if(_month < 10) {
      _month = '0'+_month;
  }
  if(_day < 10) {
      _day = '0'+_day;
  }

  var now_date  = _year+'-'+_month+'-'+_day;
  var ref = {dateSlot: now_date,createId: sid};
  // 获取 已经选择的菜品
  getMenu(ref).then(res => {
    // console.log('res:',res)
    if(res.data.code == 1) {
      if(res.data.data !== '' && res.data.data !== undefined && res.data.data !== null) {
        // console.log('data:',res.data.data)
        menusData.value = res.data.data;

        pushMenuData()

      } else {
        
        menusData.value = [];
        console.log('今天没有选择菜单');
        menuStatus.value = 0;
      }
    } else {
      menusData.value = [];
      console.log('获取失败')
    }
  })
}

// 显示状态 -> 0屏保 、1早餐、2中餐、3晚餐
const menuStatus = ref(0)

// 用于当前显示早饭
// const Menus_morning = ref({
//   normal: [],
//   special: []
// })
// 用于当前显示中饭
const Menus_noon = ref({
  dahun: [],
  xiaohun: [],
  sucai: [],
  special: []
})
// 用于当前显示晚饭
const Menus_night = ref({
  dahun: [],
  xiaohun: [],
  sucai: [],
  special: []
})

// 匹配时间早上
const pushMenu_morning = () => {
  menuStatus.value = 0;

}

// 匹配时间中午
const pushMenu_noon = () => {
  var dahun = [];
  var xiaohun = [];
  var sucai = [];
  var special = [];
  // 业务逻辑
  for(let i = 0; i < menus_list.value.lunch.dahun.length; i++) {
    for(let j = 0; j < menusData.value.lunch_dh.length; j ++) {
      if(menus_list.value.lunch.dahun[i].value ==  menusData.value.lunch_dh[j]) {
        dahun.push(menus_list.value.lunch.dahun[i].label)
      }
    }
  }

  for(let i = 0; i < menus_list.value.lunch.xiaohun.length; i++) {
    for(let j = 0; j < menusData.value.lunch_xh.length; j ++) {
      if(menus_list.value.lunch.xiaohun[i].value ==  menusData.value.lunch_xh[j]) {
        xiaohun.push(menus_list.value.lunch.xiaohun[i].label)
      }
    }
  }

  for(let i = 0; i < menus_list.value.lunch.sucai.length; i++) {
    for(let j = 0; j < menusData.value.lunch_sc.length; j ++) {
      if(menus_list.value.lunch.sucai[i].value ==  menusData.value.lunch_sc[j]) {
        sucai.push(menus_list.value.lunch.sucai[i].label)
      }
    }
  }

  for(let i = 0; i < menus_list.value.lunch.special.length; i++) {
    for(let j = 0; j < menusData.value.lunch_tb.length; j ++) {
      if(menus_list.value.lunch.special[i].value ==  menusData.value.lunch_tb[j]) {
        special.push(menus_list.value.lunch.special[i].label)
      }
    }
  }

  console.log(dahun,xiaohun,sucai,special)

  Menus_noon.value.dahun = dahun;
  Menus_noon.value.xiaohun = xiaohun;
  Menus_noon.value.sucai = sucai;
  Menus_noon.value.special = special;

  menuStatus.value = 2;

}

// 匹配时间晚上
const pushMenu_night = () => {
  var dahun = [];
  var xiaohun = [];
  var sucai = [];
  var special = [];
  // 业务逻辑
  for(let i = 0; i < menus_list.value.dinner.dahun.length; i++) {
    for(let j = 0; j < menusData.value.dinner_dh.length; j ++) {
      if(menus_list.value.dinner.dahun[i].value ==  menusData.value.dinner_dh[j]) {
        dahun.push(menus_list.value.dinner.dahun[i].label)
      }
    }
  }

  for(let i = 0; i < menus_list.value.dinner.xiaohun.length; i++) {
    for(let j = 0; j < menusData.value.dinner_xh.length; j ++) {
      if(menus_list.value.dinner.xiaohun[i].value ==  menusData.value.dinner_xh[j]) {
        xiaohun.push(menus_list.value.dinner.xiaohun[i].label)
      }
    }
  }

  for(let i = 0; i < menus_list.value.dinner.sucai.length; i++) {
    for(let j = 0; j < menusData.value.dinner_sc.length; j ++) {
      if(menus_list.value.dinner.sucai[i].value ==  menusData.value.dinner_sc[j]) {
        sucai.push(menus_list.value.dinner.sucai[i].label)
      }
    }
  }

  for(let i = 0; i < menus_list.value.dinner.special.length; i++) {
    for(let j = 0; j < menusData.value.dinner_tb.length; j ++) {
      if(menus_list.value.dinner.special[i].value ==  menusData.value.dinner_tb[j]) {
        special.push(menus_list.value.dinner.special[i].label)
      }
    }
  }

  console.log(dahun,xiaohun,sucai,special)

  if(dahun.length < 1 && xiaohun.length < 1 && sucai.length < 1 && special.length < 1) {
    menuStatus.value = 0;
    console.log('没有录入这个时间段的菜单')
    return;
  }

  Menus_night.value.dahun = dahun;
  Menus_night.value.xiaohun = xiaohun;
  Menus_night.value.sucai = sucai;
  Menus_night.value.special = special;

  menuStatus.value = 3;
}

// 根据当前时间匹配应该显示的菜单
const pushMenuData = () => {



  // 获取当前时间
  var _date = new Date();
  var now_hour = dayjs(_date).hour();
  var now_minute = dayjs(_date).minute();
  console.log('now_time:',now_hour,now_minute);

  // if(menusData.value.length < 1) {
  //   console.log('没有已经选择的菜单');
  //   return false;
  // }


  // 早
  if(now_hour >= 5 && now_hour <= 9) {
    console.log('匹配早饭时间')
    pushMenu_morning()

  } else if(now_hour >= 10 && now_hour <= 13) {
    console.log('匹配中饭时间')
    pushMenu_noon()

  } else if(now_hour >= 14 && now_hour <= 21) {


    console.log('匹配晚饭时间')
    pushMenu_night()

  } else {
    console.log('匹配其他时间')
    menuStatus.value = 0;


  }


}


const refresh = () => {
  setTimeout(function() {
    location.reload();
  }, 60000);
}


const getQuery = () => {
  var params = new URLSearchParams(window.location.search);
  var areaid = params.get('areaid');
  console.log('areaid:',areaid)
  if(areaid !== "" || areaid !== undefined || areaid !== null) {
    if(areaid == 1) {
      createId.value = 1;
      getData(createId.value);
      console.log('回调:1');
    } else if(areaid == 2) {
      createId.value = 2;
      getData(createId.value);
      console.log('回调:2');

    } else {
      createId.value = 0;
    }
  } else {
    createId.value = 0;
  }
  // console.log('areaid:',areaid)
}
// 

onMounted( async()=>{
  getQuery();
  // console.log(createId.value)

  // 先获取所有菜品
  // await getData(createId.value);
  // 去匹配对应的菜单
  refresh()
})
// import AppTime from './components/AppTime.vue'



// const menus_list = ref([
//   {id: 1, name: '锅贴'},
//   {id: 2, name: '生煎'},
//   {id: 3, name: '小笼包'}

// ])

// const titleName = ref('当天菜单 - 午餐')
// const FooterInfo = ref('沪ICP备2024053745号-2')

</script>

<style>

@font-face {
  font-family: 'Alibaba Puhui';
  src: url('./assets/fonts/AlimamaDongFangDaKai-Regular.ttf') format('truetype'); /* 根据实际路径调整 */
  font-weight: normal;
  font-style: normal;
}

html,body {
  margin: 0;
  font-family: 'Alibaba Puhui', sans-serif;
}

#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  font-family: 'Alibaba Puhui', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* color: #2c3e50; */
}

.app {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  background-color:rgb(255, 108, 40);
  /* background-image: linear-gradient(to right,#862121,#b82d2d,rgb(230, 111, 111)); */
}
.app > .container {
  display: flex;
  flex-direction: column;
  height: 79vh;
  width: 99vw;
  margin: 0.5vh 0.5vw;
  background-color: #ffffff;
  border-radius: 12px;
}

.container > .title {
  display: flex;
  flex-direction: row;
  height: 10vh;width: 100%;
}
/* .title > .title-time {
  display: flex;
  align-items: center;
  height: 8vh;width: 37%;
  font-size: 4vh;
  color: rgb(255, 108, 40);
} */

.title > .title-tip {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  height: 10vh;width: 100%;
  font-size: 8vh;
  /* text-indent: 7vw; */
  /* background-color: #e5e5e5; */
  color: rgb(255, 108, 40);
}

.container > .menus {
  display: flex;
  flex-direction: row;
  height: 65vh;width: 100%;
  margin-top: 4vh;
  /* background-color: aqua; */
}
.menus > .menus-column {
  display: flex;
  flex-direction: column;
  height: 64.5vh;width: 22%;padding-left: 2%;padding-right:  2%;
  border-top: 5px double #e5e5e5;
  border-left: 5px double #e5e5e5;
  border-right: 5px double #e5e5e5;
  /* background-color: rgb(13, 116, 116); */
}
/* .menus > .menus-border {
  border-right: 5px dashed #808080;
} */

.menus-column > .menus-column-title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 8vh;
  width: 100%;
  font-size: 7vh;
  color: #181818;

}
.menus-column > .menus-column-content {
  height: 57vh;
  width: 100%;
  font-size: 6vh;
}

/* .menus-column-content > .menus-column-content-ul {

} */

.menus-column-content-li {
  text-align: left;
  margin-top: 4vh;
  margin-bottom: 1vh;
  height: 8vh;
  width: 100%;
  font-size: 6vh;
  color: #181818;
}

.app > .footer {
  display: flex;
  flex-direction: row;
  height: 18vh;
  width: 99vw;
  margin: 0.5vh 0.5vw;
  background-color: antiquewhite;
  border-radius: 12px;
}

.footer > .footer-title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 50%;
  font-size: 6vh;
  font-weight: bold;
  font-family: serif !important;
  border-radius: 12px 0 0 12px;


}
.footer > .footer-tips {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 50%;
  font-size: 5vh;
  font-weight: bold;
  font-family: serif !important;
  border-radius: 0 12px 12px 0;
}

.footer-tips > .footer-tips-time {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 50%;
  width: 100%;
  overflow: hidden;
}
.footer-tips > .footer-tips-weather {
  display: flex;
  flex-direction: row;
  height: 50%;
  width: 100%;

}

ul{
list-style:none;    
display:flex;
flex-wrap:wrap;
margin: 0;
padding: 0;
}
li{
list-style-type:none;    
text-align: center;
margin: 0;
padding: 0;
}
li::before{    
content: "●";
font-size: 3vh;
color: rgb(0, 81, 255);
padding-right:8px;
}

/** 屏保 */
.container > .pb {

  height: 79vh;
  width: 99vw;
}
</style>


